/* Mobile Menu Button */
const menuButton = document.querySelector('.menu-button');
menuButton.addEventListener('click', function() {
    menuButton.classList.toggle('opened');
});


// This function disables dragging for all img elements.
function disableImageDrag() {
    for (var e = document.getElementsByTagName("img"), t = 0; t < e.length; t++)
        e[t].ondragstart = function () {
            return !1;
        };
}
disableImageDrag();




document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        document.querySelector('.mg-menu').classList.remove('d-none');
    }, 300);
});


document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        document.querySelector('.mobile-menu').classList.remove('d-none');
    }, 300);
});



function checkScrollPosition() {
    const mainNav = document.querySelector('.main-navigation');
    if (window.scrollY > 20.2212) {
        mainNav.classList.add('!bg-praeryx-950',"!border-white/5","!h-16","xs:!h-20");
    } else {
        mainNav.classList.remove('!bg-praeryx-950',"!border-white/5","!h-16","xs:!h-20");
    }
}
window.addEventListener('scroll', checkScrollPosition);
window.addEventListener('load', checkScrollPosition); 




function removeJavaScriptLinks() {
    let e = document.querySelectorAll(".footer-social-account-link");
    for (let t = 0; t < e.length; t++)
      e[t].href.startsWith("javascript:") && e[t].remove();
  }
  removeJavaScriptLinks();


